import { ref } from "vue";
import { useFloatingDisplay } from "./floating-display-logic";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { FloatingDto } from "./model/floating-dto";
import { useWecomaIntegration } from "@sazka/utils/gdpr/use-wecoma-integration";

export const displayExponea = ref(true);

export async function useFloatingOnOnlineBet(lottery: Lottery) {
    const { marketingConsented } = useWecomaIntegration();
    const consented = await marketingConsented();
    if (!consented) return;

    const floatingResponse = await httpClient.get<FloatingDto>(`/api/floating-element/${lottery}`);
    displayExponea.value = false;

    if (!floatingResponse.data) return;

    const { analyticsCodeName, loggedIn } = floatingResponse.data;

    const display = useFloatingDisplay(analyticsCodeName, loggedIn);
    if (!display.shouldShow(true)) return;

    (await import("./mount-floating")).mount(floatingResponse.data);
}

export async function useExponeaFloatingById(floatingID: number) {
    const { marketingConsented } = useWecomaIntegration();
    const consented = await marketingConsented();
    if (!consented) return;

    const floatingResponse = await httpClient.get<FloatingDto>(`/api/floating-element/exponea/${floatingID}`);

    if (!floatingResponse.data) return;

    if (displayExponea.value) {
        (await import("./mount-floating")).mount(floatingResponse.data);
    }
}
